import { connect } from 'react-redux';
import featureEnabled from 'shared/helper/feature';
import withRouter from 'shared/helper/with-router';
import { getLink } from 'shared/helper/link-helper';
import { getPaginationPage } from 'shared/components/Paginator';
import { searchDigitalEdits } from '../actions';
import { getAvailableDigitalEditingPurchase, getAccessType } from '../reducer';
import DigitalEdits from './DigitalEdits';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    digitalEdit = _ref.digitalEdit,
    user = _ref.user;
  var location = _ref2.location;
  return {
    accessType: getAccessType({
      digitalEdit: digitalEdit
    }),
    allowsDigitalEditing: application.allowsDigitalEditing,
    availableDigitalEditingPurchase: getAvailableDigitalEditingPurchase({
      digitalEdit: digitalEdit
    }),
    currency: user.currency,
    digitalEditEnabled: !!digitalEdit.digitalEditingPurchase,
    digitalEditingPurchase: digitalEdit.digitalEditingPurchase,
    digitalEditingSurveyUrl: getLink({
      application: application,
      linkName: 'digitalEditingSurvey'
    }),
    digitalEditingVideoUrl: getLink({
      application: application,
      linkName: 'digitalEditingVideo'
    }),
    displayDigitalEditingResults: !!digitalEdit.digitalEditingPurchase || digitalEdit.digitalEdits.length > 0,
    displayDigitalEditingVideo: !digitalEdit.digitalEditingPurchase,
    location: location,
    page: getPaginationPage({
      location: location
    }),
    status: digitalEdit.status,
    uuid: user.identity,
    isCurieLaunched: featureEnabled('curie_is_launched')
  };
};
var mapDispatchToProps = {
  searchDigitalEdits: searchDigitalEdits
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigitalEdits));